export default {"src":"/_next/static/media/ft-roadmap-statusbar.179e2e1b.svg","height":234,"width":33};